package com.arena_web.data.repository

import com.arena_web.data.api.AuthApi
import com.arena_web.data.dto.*
import com.arena_web.domain.repositories.AuthRepository

class AuthRepositoryImpl(private val authApi: AuthApi) : AuthRepository {

    override suspend fun register(request: RegisterRequest): Result<AuthResponse> =
        apiCall { authApi.register(request) }

    override suspend fun login(request: LoginRequest): Result<AuthResponse> =
        apiCall { authApi.login(request) }

    override suspend fun oauthGoogle(request: OAuthLoginRequest): Result<AuthResponse> =
        apiCall { authApi.oauthGoogle(request) }

    override suspend fun oauthApple(request: OAuthLoginRequest): Result<AuthResponse> =
        apiCall { authApi.oauthApple(request) }

    override suspend fun refresh(request: RefreshTokenRequest): Result<RefreshTokenResponse> =
        apiCall { authApi.refresh(request) }

    override suspend fun logout(request: LogoutRequest): Result<Unit> =
        apiCallUnit { authApi.logout(request) }

    override suspend fun logoutAll(): Result<Unit> =
        apiCallUnit { authApi.logoutAll() }
}
